<template>
  <div class="row">
    <div id="contentTop" />
    <transition name="el-fade-in-linear" mode="out-in">
    <!-- DEMO OF HOW INTRO BUTTON/CARDS COULD LOOK -->
    <!-- <transition name="el-fade-in-linear" mode="out-in"> -->
    <div :class="cardContainerClass" v-if="selectionCards">
      <div class="card" style="margin: 0px 10px" v-if="!shouldHideCard">
        <div class="card-header">
          <h3 class="card-title">Register as an organisation</h3>
        </div>
        <div class="card-content" style="padding-bottom: 0px">
          <h5>
            Select to gain access to:
          </h5>
          <ol>
            <li class="category">A <b>Verifications Dashboard</b> with information regarding all of your checked employees/applicants/candidates.</li>
              <img src="./images/registration-screenshot2.png" alt="verifications-dashboard" style="margin-bottom: 20px; padding-bottom: 1rem; margin-top: 20px; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);">
            <li class="category">The <b>MI Analytics Platform </b> which shows all of your verification data & insights.</li>
            <li class="category">Credit/Debit card or <b>Invoice Payments</b> (subject to terms).</li>
            <li class="category">Multiple <b>Account Organisation Structures</b> and User Access rights.</li>
          </ol>
          <div v-if="!collapsed" style="margin-top: 20px">
            <h5> Who should use an organisation account?</h5>
            <p class="category">If you are an institute or an organisation who requires the ability to verify between genuine and fake qualifications, Qualification Check will give you access to records at over 50,000 institutes across 195+ countries.</p>
            <br />
            <p class="category">Accounts can be set up to mirror your internal organisation structure, providing real time insights and analytics based on user access. Verifications can be processed by your in-house teams or by the Candidate / Applicant, with the results visible to you! Giving you full transparency every step of the way.</p>
            <br />
            <p class="category">Multiple payment methods are available, including the ability to offset costs to the Candidate / Applicant.</p>
          </div>
          <a v-if="collapsed" class="dropdown-toggle" @click="toggleCollapseMenu" href="javascript:void(0)">Learn more</a>
        </div>
        <div class="button-container card-content" style="padding-bottom: 0px">
          <a v-if="!collapsed" class="dropdown-toggle" @click="toggleCollapseMenu" href="javascript:void(0)">Close</a>
          <br />

            <button class="btn btn-fill btn-wd register-btn" style="margin: auto; display: block; margin-top: auto"
              @click="toggleCompany(), toggleRegistrationCard()">
              <span>Continue</span>
            </button>
          <div style="text-align: center">
            <router-link to="/login" style="margin: auto">Already registered? Login instead</router-link>
          </div>

          <!-- <router-link to="/login"><button class="btn pull-left" style="border: 0px">Back</button></router-link> -->
        </div>
      </div>
      <div class="card" style="margin: 0px 10px">
        <div class="card-header">
          <h3 class="card-title">Register as an individual</h3>
        </div>
        <div class="card-content" style="padding-bottom: 0px">
          <!-- <p class="category">
            Please select this option to create an <b>Individual</b>
            QualificationCheck.com account<span v-if="shareinvite">
              and access the verification shared with you</span>
          </p>
          <br /> -->
          <h5 v-if="!shouldHideCard">
            Select to gain access to:
          </h5>
          <!-- <span v-if="shouldHideCard" class="pricing-info">
            <h5>From £49*</h5>
            <p>*Plus local applicable taxes</p>
          </span> -->

          <ol>
            <li class="category">A <b>Digital Verifications Wallet</b> which will contain all of your past and present verified credentials.</li>
              <img src="./images/Wallet-screenshot.jpg" alt="wallet-photo" style="margin-top: 20px; margin-bottom: 20px; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);">
            <li class="category">The <b>Sharing Centre </b> to share your credentials publicly or privately.</li>
            <li class="category">Payment by <b>Credit/Debit</b> card.</li>
            <li class="category">Online<b> Chat Support</b>.</li>
          </ol>
          <div>
            <div v-if="!collapsed" style="margin-top: 20px">
              <h5> Who should use an individual account?</h5>
              <p class="category">As an individual user, you will have transparent upfront pricing and a simple ‘pay per verification’ by Credit or Debit Card. </p>
              <br />
              <p class="category">Once submitted, you will be provided with an update on your verification's progress within 48 hours. Don’t worry if your verification shows as Pending with the source institution.  Source records are often extensive and Qualification Check will work directly with the institute to validate your information as quickly as possible!</p>
              <br />
              <p class="category">Once verified, you’re good to go! You will be given access to a Digital Certificate and Wallet, allowing you to share your pre-verified credentials digitally with employers, institutes and through social media. </p>
              <br />
            </div>
          </div>
          <a v-if="collapsed" @click="toggleCollapseMenu" href="javascript:void(0)">Learn more</a>
        </div>
        <div class="button-container card-content" style="padding-bottom: 0px">
          <a v-if="!collapsed" @click="toggleCollapseMenu" href="javascript:void(0)">Close</a>
          <br />
          <button class="btn btn-fill btn-wd register-btn" style="margin: auto; display: block; margin-top: auto"
            @click="toggleIndividual(), toggleRegistrationCard()">
            <span>Continue</span>
          </button>
          <div style="text-align: center">
            <router-link to="/login" style="margin: auto">Already registered? Login instead</router-link>
          </div>
          <!-- <router-link to="/login"><button class="btn pull-left" style="border: 0px">Back</button></router-link> -->
        </div>
      </div>
    </div>
    </transition>
    <transition name="el-fade-in-linear" mode="out-in">


    <div class="col-md-10 col-md-offset-1 col-sm-10 col-sm-offset-1 " v-if="registrationCard">
      <div class="row">
      <div v-if="atid && atid == 17" class="col-md-4 col-sm-4">
        <div class="card">
          <div class="card-content">
            <h3 class="card-title">Need help?</h3>
            <ul>
              <li><a href="https://youtu.be/Uv9epP1pl14?feature=shared" target="_blank">What is Qualification Check?</a></li>
              <li><a href="https://www.qualificationcheck.com/wes-faqs/" target="_blank">FAQs</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div :class="{'col-md-8 col-sm-8': atid && atid == 17}" >
      <div v-if="appOwnerNotFound" class="card">
        <div class="card-header">
          <h3 class="card-title">Organisation not found!</h3>
        </div>
        <div class="card-content">
          <p>
            No organsiation found for this application page or the organisation
            is not taking applications at this time.
          </p>
          <p>
            Please close this window and ensure the link you followed is
            correct.
          </p>
          <p>
            If you have already registered, please <router-link to="/login">login</router-link>.
          </p>
          <p>
            If this error persists please contact Qualification Check support.
          </p>
        </div>
      </div>
      <div v-else-if="referralOwnerNotFound" class="card">
        <div class="card-header">
          <h3 class="card-title">Organisation not found!</h3>
        </div>
        <div class="card-content">
          <p>
            No organisation found for this referral or the organisation is not
            taking referrals at this time.
          </p>
          <p>
            Please close this window and ensure the link you followed is
            correct.
          </p>
          <p>
            If you have already registered, please <router-link to="/login">login</router-link>.
          </p>
          <p>
            If this error persists please contact Qualification Check support.
          </p>
        </div>
      </div>
      <div v-else-if="applicationOwner && applicationOwner.status == 'CLOSED'" class="card">
        <div class="card-header">
          <h3 class="card-title">Applications closed</h3>
        </div>
        <div class="card-content">
          <p>
            {{ applicationOwner.statusDescription }}
          </p>
          <p>
            If you have already registered, please <router-link to="/login">login</router-link>.
          </p>
        </div>
      </div>

      <div v-else-if="!token" class="card" v-loading="working" element-loading-spinner="qc-spinner">
        <div class="card-header">
          <div v-if="applicationOwner && applicationOwner.logo">
            <img class="partnerLogo" :src="applicationOwner.logo" />
          </div>
          <div v-if="referralOwner && referralOwner.logo">
            <img class="partnerLogo" :src="referralOwner.logo" />
          </div>
          <div v-if="applicationOwner">
            <h3 class="card-title">
              <!-- TOTAL HACK, DO THIS BETTER VIA CONFIG!! -->
              <span v-if="applicationOwner.template == 71">Next Step Toward Joining Hasbro</span>
              <span v-else>Welcome {{ applicationOwner.name }} Applicant</span>
            </h3>
            <p class="category">
              Qualification Check is the fastest way to get verified. Please fill out the form below to setup an account and verify your credentials.
            </p>
            <p class="category">&nbsp;</p>
            <div v-if="applicationOwner.name == 'HEDD'">
              <p>Qualification Check is Hedd’s trusted applicant verification partner. Through this portal, you can securely verify your qualification and share your verified credentials with employers or other third parties via email or social media.</p>
              <p>Headquartered in London, Qualification Check has been delivering academic and professional verification services since 2010. We work with universities, government bodies, healthcare organisations and employers worldwide.</p>
              <p>We verify qualifications directly with more than 54,000 primary source institutions across 195 countries, with operational support available in 18 languages. If you would like to verify your qualification(s), register by filling in the details below.</p>
            </div>
            <div v-if="applicationOwner && applicationOwner.statusDescription" data-notify="container" class="col-md-12 alert alert-warning alert-with-icon">
              <span data-notify="icon" class="fa fa-exclamation"></span>
              <span data-notify="message">
                {{ applicationOwner.statusDescription }}
              </span>
            </div>
          </div>
          <div v-else>
            <h3 class="card-title">Register as an {{ isCompany ? ' organisation' : 'individual' }}</h3>
            <p class="category">
              Please fill out the following items to create a
              QualificationCheck.com account<span v-if="shareinvite">
                and access the verification shared with you.</span>
            </p>
          </div>
        </div>
        <div class="card-content">
          <!-- BELOW: WARNING NOTIFICATION IF USER IS AN INDIVIDUAL -->
          <!-- <div v-if="!isCompany && this.atid == null" data-notify="container" class="col-md-12 alert alert-warning alert-with-icon">
            <span data-notify="icon" class="fa fa-exclamation"></span>
            <span data-notify="message">If you have been invited to be register
              by, or in application to, another organisation please use their specific registration URL they have provided to you
              in order to attach your account to theirs.
            </span>
          </div> -->
          <div v-if="isCompany" data-notify="container" class="col-md-12 alert alert-warning alert-with-icon">
            <span data-notify="icon" class="fa fa-exclamation"></span>
            <span data-notify="message">If your organisation already has an account with us ask the existing account holder to invite you as a team member via their 'Account' section.
            </span>
          </div>
          <div class="form-horizontal" data-vv-scope="start-reg-form">
            <dynamic-input label="First name" name="firstname" :validations="{ required: true }" v-model="firstname"
              key="firstname"/>
            <dynamic-input label="Last name" name="lastname" :validations="{ required: true }" v-model="lastname"
             key="lastname"/>
             <div>
              <dynamic-input label="Email" name="username" :readOnly="shareinvite != null || usernameLocked"
                :validations="{ required: true, email: true }" v-model="lowercaseUsername"
                description="Your email will be your unique username used to log into QualificationCheck.com"
                key="username" />
            </div>
            <dynamic-input v-if="r" :label="applicationOwner ? applicationOwner.referenceLabel : 'Reference'" name="reference" :readOnly="true" v-model="r" key="reference" />

            <!-- RADIO BUTTONS BELOW HERE -->
            <!-- <div
              v-if="atid == null && shareinvite == null && referralcode == null"
              class="form-group"
            >
              <label class="col-sm-2 control-label">Account Type</label>
              <div class="col-sm-10">
                <el-radio v-model="type" label="C">Company</el-radio><br />
                <el-radio v-model="type" label="I">Individual</el-radio>
              </div>
            </div> -->

            <!-- BELOW: DIV FOR COMPANY LAYOUT. IF IS TRUE SHOW, IF NOT DONT -->
            <div v-if="isCompany">
              <dynamic-input label="Company Name" name="companyName" :validations="{ required: true }"
              v-model="company.name" key="companyName"/>
              <dynamic-input label="Job Title" name="jobTitle" :validations="{ required: true }"
              v-model="jobTitle" key="jobTitle"/>
              <dynamic-input label="Phone" name="phone" :validations="{ required: true }" v-model="phone" key="phone"/>

            </div>
            <div class="col-sm-12">
              <!-- <label v-if="!isCompany && this.atid == null" class="checkbox-primary">
                <input name="terms" v-validate="'required'" type="checkbox">
                I understand that I am registering for an <b>individual</b> account and confirm I have not been invited to
                register by, or in application to, another organisation.<span style="color: red"> *</span>
              </label> -->
              <div v-if="isCompany && this.atid == null">
                <label  class="checkbox-primary" >
                  <input name="terms" v-validate="'required'" type="checkbox">
                  I understand that I am registering for an <b>organisation</b> account and will be using it to verify third party
                  qualifications<span style="color: red"> *</span>
                </label>
                <p style="color: red; font-size: 0.8em" class="help is-danger" v-show="errors.has('terms')">{{
                  errors.first('terms')
                }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer text-center">
          <small class="text-danger" v-if="errors.any()">
            Please resolve the errors above.
          </small>
          <br v-if="errors.any()" />
          <button @click.prevent="register" type="submit" v-bind:disabled="$validator.errors.any() || working"
          v-bind:class="{ 'btn-disabled': $validator.errors.any() || working }" class="btn btn-fill btn-wd">
            <i v-if="working" class="fa fa-cog fa-spin" aria-hidden="true"></i>
            <span v-else>Register</span>
          </button>

          <div v-if="(!atid && !shareinvite) || token" class="forgot" style="display: grid; grid-template-columns: 1fr 10fr 1fr">
            <button  class="btn btn-md" style="border: 0px; margin-top: -10px" @click="toggleBack()">Back</button>
            <router-link to="/login">Already registered? Login instead</router-link>
            <div></div>
          </div>
          <div v-else class="forgot">
            <router-link to="/login">Already registered? Login instead</router-link>
          </div>
        </div>
      </div>

      <div v-else class="card" v-loading="working" element-loading-spinner="qc-spinner">
        <div class="card-header">
          <div v-if="applicationOwner && applicationOwner.logo">
            <img class="partnerLogo" :src="applicationOwner.logo" />
          </div>
          <div v-if="referralOwner && referralOwner.logo">
            <img class="partnerLogo" :src="referralOwner.logo" />
          </div>
          <h3 class="card-title">Complete Registration</h3>
          <p class="category">
            Please fill out the following items to complete your
            QualificationCheck.com registration.
          </p>
          <p v-if="applicationOwner" class="category">
            You are registering in relation to an application to
            {{ applicationOwner.name }}
          </p>
        </div>
        <div class="card-content">
          <div class="form-horizontal" data-vv-scope="complete-reg-form">
            <dynamic-input label="Name" :readOnly="true" :value="name" :controlSize="9" />
            <dynamic-input v-if="company.id" label="Company" :readOnly="true" :value="company.name" :controlSize="9" />
            <dynamic-input v-if="institute.id" label="Institute" :readOnly="true" :value="institute.name"
              :controlSize="9" />
            <dynamic-input label="Username" :readOnly="true" :value="username" :controlSize="9" />
            <dynamic-input label="Password" key="password" name="password" type="PASSWORD" :tooltipPassword="true"
              :validations="{
              required: true,
              regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*\-$£])[A-Za-z\d!@#$%^&*\-$£]{6,}$/,
              min: 6,
              max: 256,
            }" v-model="password" :controlSize="9" />
            <dynamic-input label="Confirm Password" key="confirmpassword" name="confirmpassword" type="PASSWORD"
              :validations="{ required: true, confirmed: password }" v-model="confirmPassword" :controlSize="9" />
            <div v-if="!company.id && !institute.id">
              <dynamic-input v-if="type == 'C'" label="Company" :readOnly="true" :value="company.name"
                :controlSize="9" />
            <dynamic-input v-if="type == 'C'" label="Job Title" :readOnly="true" :value="jobTitle"
                :controlSize="9" />

            <div v-if="type == 'C'" class="form-group">
                <label class="col-sm-3 control-label">Annual estimated volume <span class="text-danger">*</span></label>
                <div class="col-sm-9">
                  <el-select
                    class="verification-select"
                    name="volume"
                    v-model ="volumeChecks"
                    v-bind:value="volumeChecks"
                    v-validate="{required: true}"
                    :class="{'has-error': errors.has('volume')}"
                    placeholder="Select">
                    <el-option-group label="Select an option below">
                      <el-option value="0-199" label="0-199"/>
                      <el-option value="200+" label="200+" />
                    </el-option-group>
                  </el-select>
                  <small class="text-danger" v-show="errors.has('volume')">
                    {{ errors.first('volume') }}
                  </small>
               </div>
            </div>
              <!--
                <dynamic-input v-if="type == 'C'" label="Street address" name="street1" :validations="{required: true}" v-model="company.addressStreet1" :controlSize="9" />
                <dynamic-input v-if="type == 'C'" label=" " name="street2" v-model="company.addressStreet2" :controlSize="9" />
                <dynamic-input v-if="type == 'C'" label=" " name="street3" v-model="company.addressStreet3" :controlSize="9" />
                <dynamic-input v-if="type == 'C'" label="City" name="city" :validations="{required: true}" v-model="company.addressCity" :controlSize="9" />
                <dynamic-input v-if="type == 'C'" label="Post code" name="postcode" :validations="{required: true}" v-model="company.addressPostCode" :controlSize="9" />
                -->

              <div class="form-group">
                <label class="col-sm-3 control-label">
                  Country <span class="text-danger">*</span>
                </label>
                <div class="col-sm-9">
                  <country-select v-model="company.addressCountry" />
                </div>
              </div>

              <dynamic-input v-if="
                type == 'C' &&
                company.addressCountry &&
                company.addressCountry.vat
              " label="VAT ID" name="vatid" v-model="company.vatId" :description="
                company.addressCountry.id != 'GB'
                  ? 'Due to VAT charging rules in your country, if you do not enter a VAT number you will be charged VAT.'
                  : null
              " :controlSize="9" />

              <div v-if="type != 'I'" class="form-group">
                <label class="col-sm-3 control-label">
                  Industry <span class="text-danger">*</span>
                </label>
                <div class="col-sm-9">
                  <industry-select v-model="company.industry" />
                </div>
              </div>
            </div>
            <!--
              <div class="form-group">
                <label class="col-sm-3 control-label">Keeping up to date</label>
                <div class="col-sm-9">
                  Would you like Qualification Check to keep you informed of our latest institute coverage and new services?<br/>
                  <el-radio name="marketing" v-model="marketing" v-validate="'required'" :label="true">Yes please</el-radio><br/>
                  <el-radio v-model="marketing" :label="false">No thanks</el-radio>
                  <small class="text-danger" v-show="errors.has('marketing')">
                    <br/>Please let us know if you'd like to be kept up to date
                  </small>
                </div>
              </div>
              -->
            <div class="form-group">
              <label class="col-sm-3 control-label">Terms and Privacy</label>
              <div class="col-sm-9">
                <div>
                  Please review the latest
                  <a href="https://www.qualificationcheck.com/terms-and-conditions/" title="Qualification Check™ Terms & Conditions of Use" target="_blank">terms & conditions</a>
                  and
                  <a href="https://www.qualificationcheck.com/privacy-notice/" title="Qualification Check™ Privacy Notice" target="_blank">privacy notice</a>
                  for the use of our service.
                  <span v-if="applicationOwner">Also note that as an applicant of
                    {{ applicationOwner.name }} your credential verification
                    results will be shared with them.</span>
                </div>
                I have read the above policies and<span v-if="applicationOwner">
                  consent to my data being shared with
                  {{ applicationOwner.name }}</span>;<br />
                <el-radio name="tcs" v-model="tcs" v-validate="'required:true'" :label="false">Disagree</el-radio><br />
                <el-radio v-model="tcs" :label="true">Agree</el-radio>
                <small class="text-danger" v-show="errors.has('tcs')">
                  <br />You must accept our terms & conditions<span v-if="applicationOwner">
                    and agree to share you data</span>
                  in order to use our service.
                </small>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer text-center">
          <small class="text-danger" v-if="errors.any()">
            Please resolve the errors above.
          </small>
          <br v-if="errors.any()" />
          <button @click.prevent="submit" v-bind:disabled="$validator.errors.any()"
            v-bind:class="{ 'btn-disabled': $validator.errors.any() }" type="submit" class="btn btn-fill btn-wd ">
            <i v-if="working" class="fa fa-cog fa-spin" aria-hidden="true"></i>
            <span v-else>Submit</span>
          </button>
          <div class="forgot">
            <router-link to="/login">Already registered? Login instead</router-link>
          </div>
        </div>
      </div>
    </div>
    </div>
      <div v-if="atid && atid != 17 && !appOwnerNotFound" class="card">
        <div class="card-content">
          <section>
            <iframe  class="youtube-video" style="max-width: 100%" src="https://www.youtube.com/embed/GpEIouCjeC0?rel=0" title="What is Qualification Check?" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </section>
        </div>
      </div>

    </div>
    </transition>
  </div>
</template>
<script>
import IndustrySelect from "src/components/Inputs/IndustrySelect";
import CountrySelect from "src/components/Inputs/CountrySelect";
import DynamicInput from "src/views/Verifications/components/DynamicInput";
import { SnotifyStyle } from "vue-snotify";
import LogRocket from 'logrocket'
import {version} from '../../../package.json';

export default {
  components: {
    IndustrySelect,
    CountrySelect,
    DynamicInput,
  },
  props: {
    regToken: String,
    atid: String,
    r: String,
    e: String,
    referralcode: String,
  },
  data() {
    return {
      shouldHideCard: false,
      collapsed: true,
      isCompany: false,
      selectionCards: true,
      registrationCard: false,
      firstname: null,
      lastname: null,
      username: null,
      phone: null,
      jobTitle:null,
      volumeChecks: null,
      type: "C",
      institute: {
        id: null,
        name: null,
      },
      company: {
        id: null,
        name: null,
        addressStreet1: null,
        addressStreet2: null,
        addressStreet3: null,
        addressCity: null,
        addressPostCode: null,
        addressCountry: null,
        industry: null,
        vatId: null,
      },
      password: null,
      confirmPassword: null,
      marketing: true,
      applicationConsent: null,
      tcs: null,
      token: null,
      shareinvite: null,
      applicationOwner: null,
      referralOwner: null,
      appOwnerNotFound: false,
      referralOwnerNotFound: false,
      working: false,
      keepLogo: false,
      usernameLocked: false,
    };
  },
  watch: {
    username(newValue) {
      this.username = newValue.trim()
      this.$nextTick(() => {
      this.$validator.validate();
    });
    },
    atid(newValue) {
      this.loadAppTemplate()
    }
  },
  computed: {
    cardContainerClass() {
      return this.shouldHideCard ? 'single-card' : 'grid-layout';
    },
    lowercaseUsername: {
      get() {
        return this.username;
      },
      set(value) {
        this.username = value.toLowerCase();
      },
    },
    name() {
      if (this.firstname && this.lastname) {
        return this.firstname + " " + this.lastname;
      } else {
        return "";
      }
    },
  },
  created() {
    this.token = this.$route.query.token ? this.$route.query.token : this.regToken;

    const rawShareInvite = this.$route.params.shareinvite
      ? this.$route.params.shareinvite
      : this.$route.query.shareinvite;
    this.shareinvite = rawShareInvite ? decodeURIComponent(rawShareInvite) : null;

    // Get the query parameter value from the URL
    const locationHash = window.location.hash;
    if (locationHash.includes('register-as-individual')) {
      this.shouldHideCard = true;
    }
  },
  mounted() {
    if (this.atid != null) {
      this.loadAppTemplate()
    }
    if (this.e != null) {
      this.username = this.e
      this.usernameLocked = true
      var logRocketEnv = null
        LogRocket.init('qc/selective', {
          release: version
        })
    }
    if (this.shareinvite) {
      this.toggleRegistrationCard()
      this.username = this.shareinvite;
      this.isCompany = true
      this.type = "C"
    }
    if (this.referralcode != null) {
      this.type = "C";
      this.working = true;
      this.$api
        .getReferralOwner(this.referralcode)
        .then((response) => {
          this.referralOwner = response.data;
          this.$store.commit("setPartnerLogo", response.data.partnerLogo);
          this.working = false;
        })
        .catch((error) => {
          this.working = false;
          console.log(error);
          this.referralOwnerNotFound = true;
        });
    }
    if (this.token) {
      this.toggleRegistrationCard()
      this.working = true;
      this.$api
        .getRegToken(this.token)
        .then((response) => {
          this.firstname = response.data.firstname;
          this.lastname = response.data.lastname;
          this.username = response.data.email;
          this.company.id = response.data.companyId;
          this.company.name = response.data.companyName;
          this.jobTitle = response.data.jobTitle;
          this.volumeChecks = response.data.volumeChecks;
          this.institute.id = response.data.instituteId;
          this.institute.name = response.data.instituteName;
          this.applicationOwner = response.data.applicationOwner;
          if (this.applicationOwner) {
            this.$store.commit(
              "setPartnerLogo",
              this.applicationOwner.partnerLogo
            );
          }
          this.referralOwner = response.data.referralOwner;
          if (this.referralOwner) {
            this.$store.commit("setPartnerLogo", this.referralOwner.logo);
          }
          this.type = response.data.individual ? "I" : "C";
          if (this.type == "I") {
            this.company.industry = { id: -1 };
          }
          this.working = false;
        })
        .catch((error) => {
          this.working = false;
          this.$snotify.html(
            `<a href="#/login">
              <div class="snotifyToast__title"><b>Error</b></div>
              <div class="snotifyToast__body">
                <div>Your username may already be registered, click here to login instead</div>
              </div>
            </a>`,
            {
              timeout: 7500,
              type: SnotifyStyle.error,
            }
          );
        });
    }
  },
  beforeRouteLeave(to, from, next) {
    if (!this.keepLogo) {
      this.$store.commit("setPartnerLogo", null);
    }
    next();
  },
  methods: {
    loadAppTemplate() {
      this.toggleRegistrationCard()
      this.type = "I";
      this.working = true;
      this.$api
        .getApplicationTemplateOwner(this.atid)
        .then((response) => {
          this.applicationOwner = response.data;
          this.$store.commit("setPartnerLogo", response.data.partnerLogo);
          this.working = false;
        })
        .catch((error) => {
          this.working = false;
          console.log(error);
          this.appOwnerNotFound = true;
        });
    },
    toggleBack() {
      this.collapsed = true
      setTimeout(this.toggleSelection, 300)
      this.toggleRegister()
    },
    toggleCollapseMenu() {
      this.collapsed = !this.collapsed
    },
    toggleRegistrationCard() {
      setTimeout(this.toggleRegister, 300)
      this.toggleSelection()
    },
    toggleRegister() {
      this.registrationCard = !this.registrationCard
    },
    toggleSelection() {
      this.selectionCards = !this.selectionCards
    },
    toggleCompany() {
      this.isCompany = true
      this.type = "C"
    },
    toggleIndividual() {
      this.isCompany = false
      this.type = "I"
    },
    toggleNavbar() {
      document.body.classList.toggle("nav-open");
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      document.body.classList.remove("off-canvas-sidebar");
    },
    async register() {
      try {
        const result = await this.$validator.validate();
        if (result) {
          this.working = true;
          const response = await this.$api.postRegToken({
            firstname: this.firstname,
            lastname: this.lastname,
            email: this.username,
            phone: this.phone,
            companyName: this.type === "C" ? this.company.name : null,
            jobTitle: this.type === "C" ? this.jobTitle : null,
            volumeChecks: this.type === "C" ? this.volumeChecks : null,
            individual: this.type === "I",
            applicationTemplateId: this.atid,
            referralOwnerId: this.referralOwner ? this.referralOwner.id : null,
            applicationRef: this.r ? this.r : null
          });
          this.$snotify.success(
            "Please check your email to complete your registration.",
            "Thank you!",
            {
              timeout: 7500,
            }
          );
          this.$router.push("/login");
        } else {
          this.$el.querySelector("#contentTop").scrollIntoView();
          this.$snotify.error(
            "Please correct the errors shown below.",
            "Error",
            {
              timeout: 7500,
            }
          );
          const isSamsungPhone = navigator.userAgent.includes("SM-") && navigator.userAgent.includes("Mobile") // Should only find samsung mobile users
          if (isSamsungPhone) {
            this.$snotify.warning(
              "Please note that some users have reported issues with this form whilst using the Samsung mobile keyboard. We recommend using a different device if you experience any issues.",
              "Warning",
              {
                timeout: 10000,
              }
            );
          }
          var logRocketEnv = null
          logRocketEnv = 'selective'
          LogRocket.init('omhnj3/qc-prod', {
            release: version
          })
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.working = false;
      }
    },
    submit() {
      this.$validator.validate().then((result) => {
        if (result) {
          this.working = true;
          this.$api
            .putRegCompletion(this.token, {
              password: this.password,
              confirmPassword: this.confirmpassword,
              company: this.company,
              marketing: this.marketing,
              jobTitle: this.jobTitle,
              volumeChecks: this.volumeChecks,
            })
            .then((response) => {
              this.$api
                .login(this.username, this.password)
                .then((response) => {
                  this.$snotify.success(
                    "Your registration is complete.",
                    "Welcome!",
                    {
                      timeout: 7500,
                    }
                  );
                  if (this.$store.state.isIndividual) {
                    this.$api
                      .getApplicationHistory({
                        status: ["OPEN"],
                        page: 0,
                        size: 500,
                      })
                      .then((response) => {
                        if (response.data.totalSize == 1) {
                          this.$router.push(
                            "/application/" +
                            response.data.content[0].id +
                            "/start"
                          );
                        } else {
                          this.$router.push("/");
                        }
                      });
                  } else {
                       //this.$router.push("/");
                        if (this.volumeChecks == "0-199") {
                          this.$router.push("/");
                        } else {
                          this.$router.push("/BookAMeeting");
                        }
                  }
                  this.keepLogo = true;
                })
                .catch((error) => {
                  console.log(error);
                  this.$router.push("/login");
                });
            })
            .catch((error) => {
              console.log(error);
              this.working = false;
            });
        } else {
          this.$el.querySelector("#contentTop").scrollIntoView();
          this.$snotify.error(
            "Please correct the errors shown below.",
            "Error",
            {
              timeout: 7500,
            }
          );
          var logRocketEnv = null
            logRocketEnv = 'selective'
            LogRocket.init('omhnj3/qc-prod', {
                  release: version
                })
        }
      });
    },
  },
  beforeDestroy() {
    this.closeMenu();
  },
};
</script>
<style>
.partnerLogo {
  float: right;
  max-width: 20% !important;
  max-height: 100px !important;
  object-fit: contain;
}
</style>

<style lang="scss" scoped>

.single-card {
  max-width: 600px;
  margin: auto;
}

.pricing-info {
  display: block;
}

.pricing-info h5 {
  font-size: 24px;
}

.pricing-info p {
  font-size: 14px;
  color: #666;
}

ol {
  padding-right: 15px;
  padding-left: 15px;
}

h5 {
  font-size: 1.3em;
  color: #359297;
  margin-top: 0px;
}

.card {
  display: flex;
  flex-direction: column;
}

.grid-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.button-container {
  margin-top: auto;
  margin-bottom: 15px;
  padding-top: 0px;
}

@media only screen and (max-width: 770px) {
  .grid-layout {
    display: flex;
    flex-direction: column-reverse;
  }

  .card {
    margin-bottom: 15px !important;
  }
}
</style>
